import Button from "../../components/atoms/buttons/Button";
import { LoadingIcon, OnboardingBackIcon } from "../../components/atoms/Icon";
import ProfileSettingsTab from "./UserSettingsTab";

type Props = {
  currentStep: number;
  handleBackButtonClick?: () => void;
  handleSetFormStep?: (step: string) => Promise<void>;
  handleSubmit: any;
  handleCancelButtonClick?: () => void;
  form: JSX.Element;
  isOnboard?: boolean;
  isUserProfileHashLoading?: boolean;
};

function UserSettingsPage({
  currentStep,
  handleBackButtonClick,
  handleSetFormStep,
  handleSubmit,
  handleCancelButtonClick,
  form,
  isOnboard = true,
  isUserProfileHashLoading,
}: Props) {
  return (
    <div className="flex flex-col">
      <div className="mx-auto w-full  max-w-4xl flex-1 p-2 font-sora  md:w-4/5">
        <div className="mt-8 min-h-fit overflow-y-scroll scrollbar-hide">
          {isOnboard && (
            <button
              type="button"
              className="-mt-1 mb-5 flex items-center justify-center gap-2
               font-sora text-sm font-semibold text-white"
              onClick={handleBackButtonClick}
            >
              <OnboardingBackIcon />
              <p>BACK</p>
            </button>
          )}

          <ProfileSettingsTab currentStep={currentStep} handleSetFormStep={handleSetFormStep} isOnboard={isOnboard} />
          <div className="mt-2 max-w-full ">{form}</div>
        </div>
      </div>
      <div className="flex w-full items-end justify-around py-3 shadow-2xl md:justify-end ">
        <div className=" mr-[13%] flex space-x-2">
          {isOnboard && (
            <Button
              variant="whiteOutline"
              additionalClasses="xl:text-xs 2xl:text-sm"
              text="CANCEL"
              onClick={handleCancelButtonClick}
            />
          )}
          <Button
            additionalClasses="xl:text-xs 2xl:text-sm"
            text={isOnboard ? "SAVE" : "CREATE ACCOUNT"}
            onClick={handleSubmit}
            disabled={isUserProfileHashLoading}
            variant="rustPinkSolid"
            icon={
              isUserProfileHashLoading ? (
                <div className="h-6 w-6">
                  <LoadingIcon />
                </div>
              ) : undefined
            }
          />
        </div>
      </div>
    </div>
  );
}

export default UserSettingsPage;

UserSettingsPage.defaultProps = {
  handleBackButtonClick: () => {},
  handleSetFormStep: () => {},
  handleCancelButtonClick: () => {},
  isOnboard: true,
};
